import _defineProperty from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import { withSuperJSONPage as _withSuperJSONPage } from "babel-plugin-superjson-next/tools";
var _excluded = ["slices", "meta", "websiteRefreshEnabled", "error"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import useSWR from 'swr';
import { Trans, useTranslation } from '@yoweb/next-i18next';
import { Slices } from '@yoweb/prismic-slicemachine/components/Slices';
import { HomeTemplate } from '@yoweb/prismic-slicemachine/customtypes/PageTemplateHome';
import { MarketingLayout } from '@store/components/layouts/MarketingLayout';
import { PAGE_FAQ, API_GET_DISCOUNT } from '@store/constants/routes';
import { fetcher } from '@yoweb/utils/common';
import { QUERY_PARAM_LOCALE } from '@yoweb/utils/constants/queryParams';
import { useExternalConfig } from '@store/contexts/ExternalConfig';
import { SIGNUP_DISABLED } from '@yoweb/utils/constants/errorTypes';
import { Banner } from '@yoweb/ui/components/Banner';
import { ButtonLink } from '@yoweb/ui/components/buttons';
import { InfoIcon } from '@yoweb/ui/components/Icon';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/**
 * Home page with slices.
 */
var Home = function Home(_ref) {
  var slices = _ref.slices,
      meta = _ref.meta,
      websiteRefreshEnabled = _ref.websiteRefreshEnabled,
      error = _ref.error,
      rest = _objectWithoutProperties(_ref, _excluded);

  var locale = rest.locale,
      productId = rest.productId,
      referralCode = rest.referralCode;

  var _useTranslation = useTranslation('common'),
      t = _useTranslation.t;

  var queryParams = new URLSearchParams();
  queryParams.append(QUERY_PARAM_LOCALE, locale);
  queryParams.append('productId', productId);
  if (referralCode) queryParams.append('referralCode', referralCode);

  var _useSWR = useSWR("".concat(API_GET_DISCOUNT, "?").concat(queryParams.toString()), fetcher),
      pricing = _useSWR.data;

  var _useExternalConfig = useExternalConfig(),
      globalFeatures = _useExternalConfig.globalFeatures;

  var enableRemovalSignUpYohanaUs = globalFeatures.enableRemovalSignUpYohanaUs;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [enableRemovalSignUpYohanaUs && error === SIGNUP_DISABLED && /*#__PURE__*/_jsx(Banner, {
      "data-testid": "no-signup-banner",
      backgroundColor: "criticalLight",
      dismissible: true,
      subtitle: /*#__PURE__*/_jsx(Trans, {
        t: t,
        i18nKey: "error.no-signup-banner",
        components: [/*#__PURE__*/_jsx(ButtonLink, {
          size: "md",
          rel: "noreferrer",
          href: "/contact-us"
        }, 0)]
      }),
      icon: /*#__PURE__*/_jsx(InfoIcon, {
        size: 24,
        variant: "warning"
      })
    }), /*#__PURE__*/_jsx(MarketingLayout, {
      websiteRefreshEnabled: websiteRefreshEnabled,
      showOsanoDialog: true,
      children: /*#__PURE__*/_jsx(Slices, {
        slices: slices,
        meta: meta,
        template: HomeTemplate,
        templateProps: _objectSpread(_objectSpread({
          disclaimerLink: PAGE_FAQ
        }, pricing), {}, {
          enableRemovalSignUpYohanaUs: enableRemovalSignUpYohanaUs
        })
      })
    })]
  });
};

Home.layout = {
  type: 'none'
};
export var __N_SSP = true;
export default _withSuperJSONPage(Home);